module.exports = __webpack_public_path__ + "static/media/grid-item-b3.3f8f842a.png";